module.exports = __webpack_public_path__ + "img/icon_web04_develop.90550a47.png";